var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 10.9167C22.1667 10.6866 21.9801 10.5 21.75 10.5H19.6667C17.4828 10.3912 15.6211 12.0667 15.5 14.25V16.5H13.4167C13.1865 16.5 13 16.6866 13 16.9167V19.0833C13 19.3135 13.1865 19.5 13.4167 19.5H15.5V25.0833C15.5 25.3135 15.6865 25.5 15.9167 25.5H18.4167C18.6468 25.5 18.8333 25.3135 18.8333 25.0833V19.5H21.0167C21.2073 19.5027 21.3755 19.3758 21.425 19.1917L22.025 17.025C22.0586 16.9002 22.0324 16.7669 21.9541 16.6641C21.8758 16.5614 21.7542 16.5007 21.625 16.5H18.8333V14.25C18.8763 13.8226 19.2371 13.4979 19.6667 13.5H21.75C21.9801 13.5 22.1667 13.3135 22.1667 13.0833V10.9167Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.764ecce741b3ca970cbe1197cd1268f3.svg";
export { ForwardRef as ReactComponent };